import React from "react";
import GreekCard from "Utills/GreekIslandComponent/GreekCard/GreekCard";
// css
import "./GreekIsland.css";

// GEEK island component home component
const GreekIsland = () => {
  // data
  const cardGreekData = [
    {
      text: "Santorini",
      className: "greek_low_card gre_1",
    },
    {
      text: "Corfu",
      className: "greek_high_card gre_2",
    },
    {
      text: "Zakynthos",
      className: "greek_high_card gre_3",
    },
    {
      text: "Skiathos",
      className: "greek_low_card gre_4",
    },
    {
      text: "Crete",
      className: "greek_high_card gre_5",
    },
    {
      text: "Naxos",
      className: "greek_low_card gre_6",
    },
    {
      text: "Rhodes",
      className: "greek_med_card gre_7",
    },
    {
      text: "Lefkada",
      className: "greek_med_card gre_8",
    },
    {
      text: "Mykonos",
      className: "greek_med_card gre_9",
    },
    {
      text: "Paros",
      className: "greek_med_card gre_10",
    },
    {
      text: "Milos",
      className: "greek_low_card gre_11",
    },
    {
      text: "Patmos",
      className: "greek_high_card gre_12",
    },
  ];
  // 
  return (
    <>
      <section className="greekisland" >
        <div className="greekisland_container">
          <h1>Greek Islands</h1>
          <div className="row mt-5">
            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
              {cardGreekData.slice(0, 4).map((d, i) => {
                return (
                  <GreekCard key={i} text={d.text} className={d.className} />
                );
              })}
            </div>
            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
              {cardGreekData.slice(4, 8).map((d, i) => {
                return (
                  <GreekCard key={i} text={d.text} className={d.className} />
                );
              })}
            </div>
            <div className="col-12 col-sm-12 col-md-4 col-lg-4" id="blogss">
              {cardGreekData.slice(8, 12).map((d, i) => {
                return (
                  <GreekCard key={i} text={d.text} className={d.className} />
                );
              })}
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <button className="load_more_btn">Load More</button>
          </div>
        </div>
      </section>
    </>
  );
};

export default GreekIsland;
